async function startMockApi() {
  const [
    { setupWorker },
    { handlerAppsEcommerce },
    { handlerAppsInvoice },
    { handlerAppsUsers },
    { handlerAppsEmail },
    { handlerAppsPermission },
    { handlerPagesProfile },
    { handlerAuth },
    { handlerAppsKanban },
    { handlerDashboard },
    { handlerAppPets },
    { handlerAppFoods },
  ] = await Promise.all([
    import('msw/browser'),
    import('@db/apps/ecommerce/index'),
    import('@db/apps/invoice/index'),
    import('@db/apps/users/index'),
    import('@db/apps/email/index'),
    import('@db/apps/permission/index'),
    import('@db/pages/profile/index'),
    import('@db/auth/index'),
    import('@db/apps/kanban/index'),
    import('@db/dashboard/index'),
    import('@db/apps/pet/index'),
    import('./handlers/apps/food'),
  ])

  const worker = setupWorker(
    ...handlerAppsEcommerce,
    ...handlerAppsInvoice,
    ...handlerAppsUsers,
    ...handlerAppsEmail,
    ...handlerAppsPermission,
    ...handlerPagesProfile,
    ...handlerAuth,
    ...handlerAppsKanban,
    ...handlerDashboard,
    ...handlerAppPets,
    ...handlerAppFoods,
  )

  const workerUrl = `${import.meta.env.BASE_URL ?? '/'}mockServiceWorker.js`

  await worker.start({
    serviceWorker: {
      url: workerUrl,
    },
    onUnhandledRequest: 'bypass',
  })
}

export default function () {
  const mockApiEnabled = import.meta.env.VITE_USE_MOCK_API === 'true'

  if (!mockApiEnabled) {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then(registrations => {
          registrations
            .filter(registration => registration.active?.scriptURL.includes('mockServiceWorker.js'))
            .forEach(registration => registration.unregister())
        })
        .catch(error => {
          console.warn('Failed to unregister mock service worker', error)
        })
    }

    return
  }

  startMockApi().catch(error => {
    console.warn('Failed to start mock service worker', error)
  })
}
